<script>
import appConfig from '@src/app.config'

export default {
  props: ['filters'],
  data() {
    return {
      loading: true,
      results: [],
      pagination: {},

      view_dblog: {},
    }
  },
  watch: {
    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/dblogs/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },

  }
}
</script>

<template>
  <div class="">
    <b-modal ref="modal_dblog" centered size="xl" title="Error output" :hide-footer="true">
      <!-- <pre>{{view_dblog}}</pre> -->
      <iframe
        :src="app_url+'/dblogs/fetchdisplay?id='+view_dblog.id"
        frameborder="0"
        class="w-100 _h-80vh"
      ></iframe>
    </b-modal>
    <div class="table-responsive m-0">
      <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
        <thead class="bg-white">
          <tr>
            <th class="font-weight-medium"><tdsort coltext="ID" :orderby.sync="filters.orderbys.id" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Type" :orderby.sync="filters.orderbys.type" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="User" :orderby.sync="filters.orderbys.user_id" @do="fetchData()"></tdsort></th>
            <!-- <th class="font-weight-medium"><tdsort coltext="Domain" :orderby.sync="filters.orderbys.domain" @do="fetchData()"></tdsort></th> -->
            <th class="font-weight-medium"><tdsort coltext="Page" :orderby.sync="filters.orderbys.page" @do="fetchData()"></tdsort></th>
            <!-- <th class="font-weight-medium"><tdsort coltext="Query" :orderby.sync="filters.orderbys.query_string" @do="fetchData()"></tdsort></th> -->
            <!-- <th class="font-weight-medium"><tdsort coltext="Referring domain" :orderby.sync="filters.orderbys.referring_domain" @do="fetchData()"></tdsort></th> -->
            <th class="font-weight-medium"><tdsort coltext="Referrer" :orderby.sync="filters.orderbys.referrer" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="IP address" :orderby.sync="filters.orderbys.ip_address" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Screensize" :orderby.sync="filters.orderbys.screensize" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="OS" :orderby.sync="filters.orderbys.os" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Browser" :orderby.sync="filters.orderbys.browser" @do="fetchData()"></tdsort></th>
            <!-- <th class="font-weight-medium"><tdsort coltext="User agent" :orderby.sync="filters.orderbys.user_agent" @do="fetchData()"></tdsort></th> -->
            <th class="font-weight-medium"><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
          </tr>
          <tr class="sticky-thead bg-white">
            <th class="font-weight-medium"><tdsort coltext="ID" :orderby.sync="filters.orderbys.id" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Type" :orderby.sync="filters.orderbys.type" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="User" :orderby.sync="filters.orderbys.user_id" @do="fetchData()"></tdsort></th>
            <!-- <th class="font-weight-medium"><tdsort coltext="Domain" :orderby.sync="filters.orderbys.domain" @do="fetchData()"></tdsort></th> -->
            <th class="font-weight-medium"><tdsort coltext="Page" :orderby.sync="filters.orderbys.page" @do="fetchData()"></tdsort></th>
            <!-- <th class="font-weight-medium"><tdsort coltext="Query" :orderby.sync="filters.orderbys.query_string" @do="fetchData()"></tdsort></th> -->
            <!-- <th class="font-weight-medium"><tdsort coltext="Referring domain" :orderby.sync="filters.orderbys.referring_domain" @do="fetchData()"></tdsort></th> -->
            <th class="font-weight-medium"><tdsort coltext="Referrer" :orderby.sync="filters.orderbys.referrer" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="IP address" :orderby.sync="filters.orderbys.ip_address" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Screensize" :orderby.sync="filters.orderbys.screensize" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="OS" :orderby.sync="filters.orderbys.os" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Browser" :orderby.sync="filters.orderbys.browser" @do="fetchData()"></tdsort></th>
            <!-- <th class="font-weight-medium"><tdsort coltext="User agent" :orderby.sync="filters.orderbys.user_agent" @do="fetchData()"></tdsort></th> -->
            <th class="font-weight-medium"><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
            <th class="font-weight-medium"><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in results" :key="item.id" class="_c-pointer" @click="view_dblog = JSON.parse(JSON.stringify(item)); $refs.modal_dblog.show()">
            <td><div class="text-dark font-weight-bold">{{item.id}}</div></td>
            <td>{{item.website}}</td>
            <td>{{item.type}}</td>
            <td>
              <div v-if="item.user && item.user.name" class="font-weight-bold">{{item.user.name}}</div>
              <div v-if="item.user && item.user.email">{{item.user.email}}</div>
              <div v-if="item.user && item.user.phone">{{formatPhone(item.user.phone)}}</div>
            </td>
            <!-- <td>{{item.domain}}</td> -->
            <td>{{item.page}}</td>
            <!-- <td>{{item.query_string}}</td> -->
            <!-- <td>{{item.referring_domain}}</td> -->
            <td>{{item.referrer}}</td>
            <td>{{item.ip_address}}</td>
            <td>{{item.screensize}}</td>
            <td>{{item.os}}</td>
            <td>{{item.browser}}</td>
            <!-- <td>{{item.user_agent}}</td> -->
            <td v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td>
            <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
          </tr>
        </tbody>
      </table>
      <div class="p-3 border-top border-light">
        <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
      </div>
    </div>
  </div>
</template>
